import { MIN_PASSWORD_LENGTH } from "../../modal/auth/validation";

interface PasswordRequirementsHintsProps {
  password: string;
  confirmPassword?: string;
}

const PasswordRequirementsHints: React.FC<PasswordRequirementsHintsProps> = ({
  password,
  confirmPassword = "",
}) => {
  if (!password) return null;

  const hasMinLength = password.length >= MIN_PASSWORD_LENGTH;
  const hasUppercase = /[A-Z]/.test(password);
  const showMatchRule = Boolean(confirmPassword);
  const passwordsMatch =
    showMatchRule &&
    password === confirmPassword &&
    confirmPassword.length > 0;

  const itemStyle = (met: boolean): React.CSSProperties => ({
    color: met ? "#198754" : "#dc3545",
    fontSize: 14,
    lineHeight: 1.45,
  });

  return (
    <ul
      className="mb-3 ps-3"
      style={{ marginTop: -12, listStyleType: "disc" }}
      aria-live="polite"
    >
      <li style={itemStyle(hasMinLength)}>
        At least {MIN_PASSWORD_LENGTH} characters
      </li>
      <li style={itemStyle(hasUppercase)}>At least 1 uppercase letter</li>
      {showMatchRule ? (
        <li style={itemStyle(passwordsMatch)}>
          {passwordsMatch ? "Password match" : "Password does not match"}
        </li>
      ) : null}
    </ul>
  );
};

export default PasswordRequirementsHints;
